module.exports = __webpack_public_path__ + "static/media/language.7486025b.webp";